export class GetUserList {
    constructor(userRepository) {
      this.userRepository = userRepository;
    }
  
    async execute(companyId) {
        console.log("repository", companyId)
      return await this.userRepository.getUserList(companyId);
    }
  }